import { queryOptions } from '@tanstack/react-query'

import { TranslationsService } from '@inter-ikea-kompis/services'
import type { ITranslations } from '@inter-ikea-kompis/types'

import type { SofaTranslation } from '@/i18n'
import { KOMPIS_SERVICE_BASE_SETTINGS } from '@/integrations/kompis/constants'

export type SofaTranslations = ITranslations & SofaTranslation

export function translationsQueryOptions(locale: string) {
  return queryOptions({
    queryFn: () => fetchTranslations(locale),
    queryKey: ['translations', locale],
    staleTime: Infinity,
  })
}

async function fetchTranslations(locale: string) {
  const translationService = new TranslationsService<SofaTranslations>({
    ...KOMPIS_SERVICE_BASE_SETTINGS,
    locale,
  })

  const translations = await translationService.getTranslations()

  return translations
}
